import { mapContactLensesLineItem } from './line-item/contact-lenses.js';
import { mapContactLensesBundleBeneluxLineItem } from './line-item/contact-lenses-bundle-benelux.js';
import { mapContactLensesSubscriptionLineItem } from './line-item/contact-lenses-subscription.js';
import { mapNonPrescriptionBundleLineItem } from './line-item/non-prescription-bundle.js';
import { mapPrescriptionGlassesLineItem } from './line-item/prescription-glasses.js';
import { mapRegularLineItem } from './line-item/regular.js';

// Map line items to the server model
const mapDraftLineItemToServer = (lineItemDraft)=>{
    switch(lineItemDraft.type){
        case 'contact-lenses':
            return mapContactLensesLineItem(lineItemDraft);
        case 'contact-lenses-bundle-benelux':
            return mapContactLensesBundleBeneluxLineItem(lineItemDraft);
        case 'contact-lenses-subscription':
            return mapContactLensesSubscriptionLineItem(lineItemDraft);
        case 'prescription-glasses':
            return mapPrescriptionGlassesLineItem(lineItemDraft);
        case 'non-prescription-bundle':
            return mapNonPrescriptionBundleLineItem(lineItemDraft);
        case 'regular':
            return mapRegularLineItem(lineItemDraft);
    }
};

export { mapDraftLineItemToServer };
//# sourceMappingURL=line-item.js.map
